import ACYWidgetForm from './component'

export default ACYWidgetForm
